import { Link } from "react-router-dom";
import { Globe, MapPin, Phone, Star } from "lucide-react";
import PageMeta from "./PageMeta";

const shops = [
  { name: "Ammodytes Co Ltd", town: "St Ives", phone: "01736 797086", url: "http://www.ammodytes.co.uk", rating: 4.3, reviews: 3 },
  { name: "Anglers Den", town: "Hayle", postcode: "TR27 4DX", phone: "07733 272524", url: "https://www.facebook.com/anglersden58", rating: 4.7, reviews: 66 },
  { name: "Aqua Sport International", town: "Newquay", phone: "07983 671091", rating: 5.0, reviews: 3 },
  { name: "Art of Fishing", town: "Wadebridge", url: "https://artoffishing.co.uk", rating: 4.9, reviews: 58 },
  { name: "Atlantic Edge Tackle", town: "Helston", postcode: "TR12 7AU", phone: "07472 453332", url: "https://atlanticedgetackle.co.uk", rating: 4.7, reviews: 126 },
  { name: "Bake Fishing Lakes", town: "Saltash", phone: "07798 585836", rating: 4.7, reviews: 109 },
  { name: "Dave Dunstan — Premier Baits", town: "Redruth", phone: "07770 688207", note: "High quality bait including lug, black lug, ragworm, sandeel and frozen squid, mackerel, herring etc. Available most days." },
  { name: "Fairwater Fishing", town: "Looe", phone: "01503 265772", rating: 5.0, reviews: 2 },
  { name: "Fishing for Pleasure", town: "Wadebridge", phone: "07763 748148", rating: 5.0, reviews: 1 },
  { name: "Fishing Tackle & Bait", town: "Newquay", rating: 3.7, reviews: 3 },
  { name: "Gwinear Angling Tackle Shop", town: "Newquay", postcode: "TR8 5JX", phone: "01637 210045", url: "http://www.gwinearangling.co.uk", rating: 4.8, reviews: 235 },
  { name: "Gwinear Camping", town: "Newquay", phone: "01637 830172", rating: 4.8, reviews: 192, note: "Open 24 hours" },
  { name: "Jack Bray & Son", town: "Looe", postcode: "PL13 1AL", phone: "01503 262504", rating: 4.7, reviews: 26 },
  { name: "Jims (Redruth)", town: "Redruth", postcode: "TR15 2AQ", phone: "01209 240430", url: "http://www.jimsonline.co.uk", rating: 4.5, category: "Department store" },
  { name: "Jims (Penzance)", town: "Penzance", postcode: "TR18 2SS", phone: "01209 240430", url: "http://www.jimsonline.co.uk", rating: 4.5, category: "Department store" },
  { name: "Jims (Camborne)", town: "Camborne", postcode: "TR14 8AW", phone: "01209 240430", url: "http://www.jimsonline.co.uk", rating: 4.5, category: "Department store" },
  { name: "Looe Chandlery", town: "Looe", phone: "01503 264355", rating: 4.3, reviews: 65 },
  { name: "Lowen-Chy Angling", town: "St Austell", phone: "01726 75631", url: "https://www.lowen-chy-angling.com", rating: 4.8, reviews: 192 },
  { name: "Lure Heaven", town: "Cornwall", phone: "07549 143372", rating: 3.7, reviews: 16, note: "Delivery" },
  { name: "Macsalvors (Redruth)", town: "Redruth", postcode: "TR15 3RS", phone: "01209 212125", url: "https://www.macsalvors.com" },
  { name: "Macsalvors Boathouse (Penryn)", town: "Penryn", postcode: "TR10 8AE", phone: "01326 377131", url: "https://www.macsalvors.com" },
  { name: "MarineCo", town: "Saltash", phone: "01752 843698", rating: 4.7, reviews: 3, category: "Marine Supply Shop" },
  { name: "Milemead Lakes and Tackle Ltd", town: "Tavistock", phone: "01822 610888", rating: 4.8, reviews: 199, category: "Fish Farm", note: "Open 24 hours" },
  { name: "Newline Chandlery Ltd", town: "Penzance", phone: "01736 363107", rating: 4.6, reviews: 18, category: "Marine Supply Shop" },
  { name: "Newtown Angling Centre", town: "Penzance", postcode: "TR20 9AE", phone: "01736 763721", url: "http://www.newtownangling.com", rating: 4.8, reviews: 149 },
  { name: "Ocean Sports", town: "St Austell", phone: "01726 842817", rating: 3.9, reviews: 20 },
  { name: "Osborne and Cragg Fishing Tackle", town: "Plymouth", phone: "01752 223141", rating: 4.9, reviews: 117 },
  { name: "Padstow Angling Centre", town: "Padstow", phone: "01841 532762", rating: 4.5, reviews: 52 },
  { name: "Penzance Angling Centre", town: "Penzance", postcode: "TR18 2EG", phone: "01736 364105", url: "https://www.facebook.com/PzAnglingCentre", rating: 5.0, reviews: 69 },
  { name: "Peter's Fishing and Sports", town: "Plymouth", phone: "07970 628740", rating: 4.6, reviews: 45 },
  { name: "Reefers Fishing Tackle", town: "Falmouth", postcode: "TR11 4SN", phone: "07561 565762", rating: 4.9, reviews: 76 },
  { name: "Rob's Bait & Tackle Supplies", town: "Plymouth", phone: "07752 651636", rating: 4.9, reviews: 137 },
  { name: "Rock Fishing Tackle", town: "Wadebridge", postcode: "PL27 6NS", phone: "01208 862815", url: "https://rockfishingtackle.co.uk", rating: 5.0, reviews: 16 },
  { name: "Sling Your Hook", town: "Newquay", phone: "01637 852101", url: "https://www.facebook.com/slingyourhook/?locale=en_GB", rating: 4.6, reviews: 76 },
  { name: "South West Sea Baits", town: "Plymouth", phone: "01752 777554", rating: 4.9, reviews: 94 },
  { name: "Spearfishing UK", town: "St Austell", postcode: "PL25 3RF", phone: "01726 213290", url: "http://www.spearfishing.co.uk" },
  { name: "St Ives Fishermens Co-operative", town: "St Ives", phone: "01736 796276", rating: 4.7, reviews: 28 },
  { name: "Stewarts Angling Services", town: "St Austell", phone: "01726 822463", url: "http://www.stewarts-angling-services.com", rating: 5.0, reviews: 4 },
  { name: "Stuart-Tackle", town: "Plymouth", phone: "07521 252923", rating: 4.8, reviews: 26 },
  { name: "The Fisherman's Locker", town: "W Wharf", phone: "07821 178137" },
  { name: "The Reeds View Tackle Shop", town: "Hayle", postcode: "TR27 5JS", phone: "07491 041966", url: "http://www.kernowfishery.co.uk", rating: 5.0, reviews: 2 },
  { name: "Trago Mills Falmouth", town: "Falmouth", postcode: "TR11 3LG", phone: "01326 315738", url: "https://www.trago.co.uk/falmouth-store", note: "Mon–Sat 9am–4:30pm · Sun 9:30am (browsing) / 10am–4pm" },
  { name: "West Country Leeds Leads", town: "Falmouth", phone: "07812 212416", rating: 4.5, reviews: 8, note: "Open 24 hours" },
  { name: "White Acres Fisheries", town: "Newquay", phone: "01726 862519", rating: 4.4, reviews: 490, category: "Fishing Lake", note: "On-site tackle shop" },
  { name: "WSB Tackle Ltd", town: "Redruth", postcode: "TR16 4ES", phone: "01209 215000", url: "http://www.wsbtackle.com", rating: 3.5, reviews: 8, category: "Wholesaler" },
  { name: "Amethyst Fishing Company Limited", town: "Mylor Bridge", phone: "01326 378441", rating: 4.0, reviews: 2, note: "Temporarily closed" },
];

const categoryColors = {
  Wholesaler: "text-amber-300 border-amber-300/30 bg-amber-400/10",
  "Marine Supply Shop": "text-violet-300 border-violet-300/30 bg-violet-400/10",
  "Department store": "text-emerald-300 border-emerald-300/30 bg-emerald-400/10",
  "Fish Farm": "text-sky-300 border-sky-300/30 bg-sky-400/10",
  "Fishing Lake": "text-sky-300 border-sky-300/30 bg-sky-400/10",
};

function mapsUrl(shop) {
  const location = shop.postcode || shop.town;
  const query = `${shop.name}, ${location}, UK`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

function ShopCard({ shop }) {
  const badgeClass =
    (shop.category && categoryColors[shop.category]) ||
    "text-slate-300 border-slate-300/30 bg-slate-400/10";

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/5 p-6 text-left transition hover:border-cyan-300/30 hover:bg-cyan-400/5 h-full panel-lift">
      {shop.category && (
        <span className={`self-start rounded-full border px-3 py-0.5 text-xs font-semibold ${badgeClass}`}>
          {shop.category}
        </span>
      )}

      <p className="text-base font-bold text-white leading-snug">{shop.name}</p>

      {shop.rating && (
        <span className="inline-flex items-center gap-1 text-xs text-amber-300">
          <Star className="h-3.5 w-3.5 shrink-0 fill-current" />
          {shop.rating.toFixed(1)}
          {shop.reviews ? <span className="text-slate-400">({shop.reviews})</span> : null}
        </span>
      )}

      <a
        href={mapsUrl(shop)}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-xs text-cyan-300 hover:text-cyan-200"
      >
        <MapPin className="h-3.5 w-3.5 shrink-0" />
        {shop.postcode || shop.town}
      </a>

      {shop.note && (
        <span className="text-xs text-slate-400">{shop.note}</span>
      )}

      <div className="mt-auto flex flex-col gap-1.5">
        {shop.phone && (
          <a
            href={`tel:${shop.phone.replace(/\s+/g, "")}`}
            className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-slate-200"
          >
            <Phone className="h-3.5 w-3.5 shrink-0" />
            {shop.phone}
          </a>
        )}
        {shop.url && (
          <a
            href={shop.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs text-cyan-300 hover:text-cyan-200"
          >
            <Globe className="h-3.5 w-3.5 shrink-0" />
            {shop.url.replace(/^https?:\/\//, "")}
          </a>
        )}
      </div>
    </div>
  );
}

export default function TackleShopsPage() {
  return (
    <>
      <PageMeta
        title="Tackle & Bait Shops | Redruth Sea Angling Association"
        description="A directory of local tackle and bait shops across Cornwall and Devon, with contact details, ratings, and Google Maps links — from Redruth Sea Angling Association."
        keywords="tackle shop Cornwall, bait shop Cornwall, fishing tackle shop, sea fishing bait, angling shop Cornwall, fishing tackle Devon, Redruth Sea Angling Association"
        url="https://www.redruthseaanglingassociation.co.uk/tackle-shops"
        image="https://www.redruthseaanglingassociation.co.uk/assets/background_tackle_shops.png"
      />
    <div className="relative page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <img
        src="/assets/background_tackle_shops.webp"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-slate-950/80" />
      <div className="relative mx-auto max-w-5xl px-6 py-16 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
          <h1 className="heading-glow mt-3 text-4xl font-bold tracking-tight text-white sm:text-5xl">Tackle &amp; Bait Shops</h1>
          <p className="mt-4 text-base leading-7 text-slate-400">
            A directory of local tackle and bait shops across Cornwall and Devon. Tap a location to open it in Google Maps.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {shops.map((shop) => (
            <ShopCard key={shop.name} shop={shop} />
          ))}
        </div>

        <p className="mt-12 text-center text-xs text-slate-500">
          Know a tackle or bait shop we should list? Get in touch via the{" "}
          <Link to="/" className="text-cyan-400 hover:text-cyan-300 underline">contact section</Link> on our homepage.
        </p>

      </div>
    </div>
    </>
  );
}
